<template>
  <b-modal :id="id" title="Add New Examinee" @show="resetModal" @hidden="resetModal" @ok="handleOk">
    <b-table
      stacked
      class="align-middle"
      :borderless="true"
      :fields="[
          {
            key: 'creditGroup',
            label: 'Credit Group'
          },
          {
            key: 'credits',
            label: 'Total Credits'
          },
          {
            key: 'nonActiveExamineeCount',
            label: 'Non-Active Examinees',
          },
          {
            key: 'availableCredits',
            label: 'Available Credits'
          },
          {
            label: 'Options'
          },
          {
            key: 'newExaminees',
            label: 'New Examinees'
          },
          {
            key: 'expiryDate',
            label: 'Examinee Expiry'
          },
        ]"
      :items="[{
        credits,
        nonActiveExamineeCount,
        availableCredits
      }]"
    >
      <template v-slot:cell(creditGroup)>
        <b-form-select v-model="selectedCreditGroup" :options="creditGroupOptions" placeholder="Select a Credit Group..."></b-form-select>
      </template>
      <template v-slot:cell(options)>
        <b-form-input type="password" v-model="confirmPassword"></b-form-input>
      </template>
      <template v-slot:cell(newExaminees)>
        <b-form-input v-model="newExaminees" @keypress="filterNumberOnlyWithMax($event)"></b-form-input>
      </template>
      <template v-slot:cell(expiryDate)>
        <b-form-datepicker v-model="expiryDate"></b-form-datepicker>
      </template>
    </b-table>

    <template v-slot:modal-footer="{ ok, cancel }">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="sm" variant="secondary" @click="cancel()">Cancel</b-button>
      <b-button
        size="sm"
        :disabled="!isFormValid ? `disabled` : null "
        variant="primary"
        class="bg-site-primary"
        @click="ok()"
      >Generate Examinee Accounts</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: `ExamineeAddModal`,
  data() {
    return {
      selectedCreditGroup: null,
      newExaminees: 0,
      expiryDate : new Date()
    };
  },
  props: {
    id: {
      type: String
    },
    clientId : String,
    creditGroupList: Array,
    examineeList : Array,
  },
  computed: {
    creditGroupOptions(){
      var options = []
      if(Array.isArray(this.creditGroupList)){
        options = this.creditGroupList.map(creditGroup => {
          return {
            text: `${creditGroup.name} (${creditGroup.credits} Credits)`,
            value: creditGroup,
          }
        })
      }
      return options
    },
    availableCredits(){
      return this.credits - this.nonActiveExamineeCount
    },
    isFormValid() {
      const isCreditGroupValid = this.selectedCreditGroup != null,
        isExamineesValid = !isNaN(this.newExaminees) && this.newExaminees > 0 && this.newExaminees <= this.availableCredits
      return isCreditGroupValid && isExamineesValid
    },
    credits(){
      return this.selectedCreditGroup ? this.selectedCreditGroup.credits : 0
    },
    nonActiveExamineeCount() {
      let examineeList = this.examineeList || [];
      var count = 0;
      examineeList.forEach((examinee) => {
        if (examinee.status != `created`) count++;
      });
      return count;
    },
  },
  methods: {
    filterNumberOnlyWithMax(evt) {
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        if (isNaN(this.newExaminees) || this.newExaminees < 0) {
          this.newExaminees = 0;
        }
        return true;
      }
    },
    resetModal() {
      var dateNow = new Date()
      dateNow.setFullYear(dateNow.getFullYear() + 1);
      this.expiryDate = dateNow
    },
    handleOk() {
      // Check if Values are complete
      if (!this.isFormValid) {
        return false;
      } 
      else {
        const clientId = this.clientId,
          creditGroupId = this.selectedCreditGroup.id,
          examineeCount = this.newExaminees,
          expiry = this.expiryDate
        this.$store
          .dispatch(`user/generateExaminees`, { clientId, creditGroupId, examineeCount, expiry })
          .then(() => {
            this.$emit("ok");
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>